import type { StatusTone } from '@noor/ui';
import type { VendorBroadcastStatus } from '../model/schema';

/**
 * Status pill tones — the old panel's orange/grey/green/red/red, in design
 * tokens. `expired` shares `rejected`'s danger tone; the label keeps them
 * distinct.
 */
export const BROADCAST_STATUS_TONES: Record<VendorBroadcastStatus, StatusTone> = {
  fresh: 'pending',
  viewed: 'neutral',
  accepted: 'success',
  rejected: 'danger',
  expired: 'danger',
};

/** `common:broadcasts.*` label key per status (kept static for grep-ability). */
export const BROADCAST_STATUS_LABEL_KEYS: Record<VendorBroadcastStatus, string> = {
  fresh: 'broadcasts.fresh',
  viewed: 'broadcasts.viewed',
  accepted: 'broadcasts.accepted',
  rejected: 'broadcasts.rejected',
  expired: 'broadcasts.expired',
};
